import { makeStyles, Theme } from "@material-ui/core";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import React from "react";
import { Link } from "react-router-dom";

interface SectionCardFooterLinkProps {
  children?: React.ReactNode;
  to?: string;
  href?: string;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  className?: string;
  dataTestId?: string;
}

export default function SectionCardFooterLink({
  children,
  to,
  href,
  onClick,
  className = "",
  dataTestId,
}: SectionCardFooterLinkProps) {
  const classes = useStyles();
  const rootClass = `${classes.root} ${className}`;
  const content = (
    <>
      <span className={classes.label}>{children}</span>
      <ChevronRightIcon className={classes.icon} />
    </>
  );

  if (to) {
    return (
      <Link
        to={to}
        onClick={onClick}
        className={rootClass}
        data-testid={dataTestId}
      >
        {content}
      </Link>
    );
  }

  if (href) {
    return (
      <a
        href={href}
        onClick={onClick}
        className={rootClass}
        data-testid={dataTestId}
      >
        {content}
      </a>
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      className={`${rootClass} ${classes.button}`}
      data-testid={dataTestId}
    >
      {content}
    </button>
  );
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    color: theme.palette.primary.main,
    fontSize: 16,
    fontWeight: 400,
    lineHeight: "24px",
    letterSpacing: "0.15px",
    textDecoration: "none",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  button: {
    background: "none",
    border: "none",
    padding: 0,
    font: "inherit",
  },
  label: {
    display: "inline-block",
  },
  icon: {
    marginTop: -2,
    flexShrink: 0,
  },
}));
